const DividerOverride = {
  Divider: {
    baseStyle: {
      opacity: 1,
    },
  },
};

export default DividerOverride;
